var map = {
	"./aed-behance.jpg": "aa05",
	"./aed-cover.jpg": "0116",
	"./fitness-behance-2.jpg": "15b3",
	"./fitness-group.jpg": "0502",
	"./fitness.jpg": "2b84",
	"./ramadan-behance.jpg": "9503",
	"./ramadan-cover.jpg": "0518",
	"./vasty-behance.jpg": "580a",
	"./vasty-cover.jpg": "af9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";